//import config from '../config';
import React,{Component} from "react";
//import Paper from "@material-ui/core/Paper";
import Tab from "@material-ui/core/Tab";
import { Tabs,Box } from "@material-ui/core";
// from "@material-ui/core/Tabs";
import Cookies from "universal-cookie";
import AdminVehRepair from "./AdminVehRepair";
import AdminFuelMonthWise from "./AdminFuelMonthWise";

const cookies = new Cookies();

const axios = require("axios");
const ref = React.createRef();
class AdminVehicleupkeep extends Component{
    constructor(props)
    {
        super(props);
//           this.state={value:0,tab1:"block",tab2:"none",tab3:"none",tab4:"none",tab5:"none",path:cookies.get("phpclass").substring(0,cookies.get("phpclass").length-3)};
           this.state={value:0,tab1:"block",tab2:"none",path:cookies.get("phpclass").substring(0,cookies.get("phpclass").length-3)};

    }    
    render(){
        return(
            <div className="containera1">
                <p style={{float:"right", width:"100px"}}>HEAD OFFICE</p>
                    <Box position="static"  >
                        <Tabs
                            value={this.state.value}
                            textColor="inherit"
                            indicatorColor="secondary"
                            style={{marginLeft:"50px"}}
                            onChange={(event, newValue) => {if(newValue == 0) this.setState({value:newValue,tab1:"block",tab2:"none"}); else this.setState({value:newValue,tab1:"none",tab2:"block"});
                            }}
                            >
                            <Tab label="Fuel Detail" > </Tab> 
                            <Tab label="Repair and Maintenance"></Tab>
                        </Tabs>
                    </Box>
                    <div  style={{display:this.state.tab1,marginLeft:"10%"}}>
                            <AdminFuelMonthWise apipath={this.state.path+"ci2"}/>
                    </div>

{/*Tab 2*/}

                    <div  style={{display:this.state.tab2,marginLeft:"10%"}}>
                        <AdminVehRepair apipath={this.state.path+"ci2"}/>
                    </div>
                    <br></br><br></br>
                </div>
    )}
}
export default AdminVehicleupkeep;